import React from 'react';
import { RenderImagesData } from './types';

export type DirectUrlViewerImage<TImage> = {
    imageUrl: string;
} & TImage;

export type DirectUrlImageProviderOwnProps<TImage> = {
    children: (renderImagesData: RenderImagesData<DirectUrlViewerImage<TImage>>) => React.ReactNode;
    image: DirectUrlViewerImage<TImage>;
};

export type DirectUrlImageProviderProps<TImage> = DirectUrlImageProviderOwnProps<TImage>;

const DirectUrlImageProvider = <TImage,>(props: DirectUrlImageProviderProps<TImage>): React.ReactNode => {
    const [isFocused, setIsFocused] = React.useState<boolean>(false);
    const renderImagesData: RenderImagesData<DirectUrlViewerImage<TImage>> = {
        viewerImages: [
            {
                uri: props.image.imageUrl,
                imageId: props.image.imageUrl,
                imageFetchUrl: props.image.imageUrl,
            },
        ],
        appDisplayImages: [
            {
                ...props.image,
                imageId: props.image.imageUrl,
            },
        ],
        imageIndex: 0,
        isOpen: isFocused,
        onClose: () => setIsFocused(false),
        getIsPressEnabled: () => true,
        onPress: () => setIsFocused(true),
    };

    return props.children(renderImagesData);
};

export default DirectUrlImageProvider;
